import { NumberData } from '@/types/common';

export const inventoryStatus: NumberData = {
  1: '棚卸実施中',
  2: '棚卸確定'
};

/** 管理列「外」表示対象の品番（Stock / Inventory 共通） */
export const EXTERNAL_MANAGEMENT_PART_CODES = new Set([
  '98970001',
  '98970002',
  '98970003',
  '98970004',
  '98970005',
  '98971001',
  '98971002',
  '98971003',
  '98972001',
  '99980001'
]);

export const isExternalManagementPart = (
  partCode: string | null | undefined
): boolean => !!partCode && EXTERNAL_MANAGEMENT_PART_CODES.has(partCode);

export const externalManagementLabel = (
  partCode: string | null | undefined
): string => (isExternalManagementPart(partCode) ? '外' : '');
